import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "href", "disabled", "inline", "visited", "renderIcon", "size"];

/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import cx from 'classnames';
import React from 'react';
import { usePrefix } from '../../internal/usePrefix';
var Link = /*#__PURE__*/React.forwardRef(function Link(_ref, ref) {
  var _cx;
  var children = _ref.children,
    customClassName = _ref.className,
    href = _ref.href,
    disabled = _ref.disabled,
    inline = _ref.inline,
    visited = _ref.visited,
    Icon = _ref.renderIcon,
    size = _ref.size,
    rest = _objectWithoutProperties(_ref, _excluded);
  var prefix = usePrefix();
  var className = cx("".concat(prefix, "--link"), customClassName, (_cx = {}, _defineProperty(_cx, "".concat(prefix, "--link--disabled"), disabled), _defineProperty(_cx, "".concat(prefix, "--link--inline"), inline), _defineProperty(_cx, "".concat(prefix, "--link--visited"), visited), _defineProperty(_cx, "".concat(prefix, "--link--").concat(size), size), _cx));
  var rel = rest.target === '_blank' ? 'noopener' : null;
  var linkProps = {
    className: className,
    rel: rel
  }; // Reference for disabled links:
  // https://www.scottohara.me/blog/2021/05/28/disabled-links.html

  if (!disabled) {
    linkProps.href = href;
  } else {
    linkProps.role = 'link';
    linkProps['aria-disabled'] = true;
  }
  return /*#__PURE__*/React.createElement("a", _extends({
    ref: ref
  }, linkProps, rest), children, !inline && Icon && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "--link__icon")
  }, /*#__PURE__*/React.createElement(Icon, null)));
});
Link.displayName = 'Link';
export default Link;